export class AccessRequest {
    id?: string;
    vesselId: string;
    userName: string;
    userOid: string;
    version: string;
    requestStatus: AccessRequestStatus;
    isEditing: boolean;
    messageRead: boolean;
}

export enum AccessRequestStatus {
    Undefined = 'undefined',
    Pending = 'pending',
    Accepted = 'accepted',
    Rejected = 'rejected',
    Editing = 'editing',
    Leave = 'left',
    Removed = 'removed',
    Finished = 'finished',
}
